<template>
  <header class="header">{{ title }}</header>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  height: 30px;
  background: #007aff;
  line-height: 30px;
  color: #fff;
  text-align: center;
  font-size: 16px;
}
</style>
